import { AuditLogTable } from '../../components/audit/AuditLogTable';
import { PageHeading } from '../../layouts/PageHeading';

export default function AuditCrossTenant() {
  return (
    <div>
      <PageHeading scope="Verifica" target="cross-azienda" meta="Log immutabile delle modifiche di dominio" />
      <AuditLogTable availableTenants={[]} availableActors={[]} />
    </div>
  );
}
